import { memo, useEffect } from 'react';
import { Modal, Button, Checkbox, Form } from "antd";
import { DisclaimerType } from 'const';
import IntlMessages from '../Message/IntlMessages';
import DisclaimerMessage from '../Message/DisclaimerMessage';
import compact from 'lodash/compact'

const HNW = ({
  close, actions, state, ...modalProps
}) => {

  const [form] = Form.useForm()

  useEffect(() => {
    if (!modalProps.visible) form.resetFields()
  }, [form, modalProps.visible])

  function _onAccept({ acceptDisc09, acceptDisc10, acceptDisc11 }) {
    const accepts = compact([
      DisclaimerType.HNW,
      acceptDisc09 && DisclaimerType.HNW_SPOUSE,
      acceptDisc10 && DisclaimerType.HNW_INCOME_4M_OR_MORE,
      acceptDisc11 && DisclaimerType.HNW_INVESTMENT_10_MILLION,
    ])

    close()
    actions?.onAccept && actions.onAccept(accepts)
  }

  function _onCancel() {
    close();
    actions?.onCancel && actions.onCancel();
  }

  const renderCheckboxFormItem = (name, code) => (
    <Form.Item name={name}
      className="form-with-no-explain"
      valuePropName="checked">
      <Checkbox>
        <span className="user-select-none">
          <DisclaimerMessage code={code} />
        </span>
      </Checkbox>
    </Form.Item>
  )

  return (
    <Modal {...modalProps}>
      {modalProps.visible && (
        <Form form={form} onFinish={_onAccept}>
          <div className="mnc-modal-disclaimer">
            <div className="modal-mnc-head">
              <h5 className="m-0">
                <IntlMessages id={state?.title ? state.title : "modal.disclaimer.header.hnw"} />
              </h5>
              <Button className="btn button-ktb-close" onClick={_onCancel}>
                <i className="feather-icon icon-x"></i>
              </Button>
            </div>
            <div className="modal-mnc-body">
              <DisclaimerMessage code={DisclaimerType.HNW} dangerous />
              <div className="accept-checkbox mx-0 mb-0">
                <div className="form-check mb-3">
                  {renderCheckboxFormItem('acceptDisc09', DisclaimerType.HNW_SPOUSE)}
                </div>
                <div className="form-check mb-3">
                  {renderCheckboxFormItem('acceptDisc10', DisclaimerType.HNW_INCOME_4M_OR_MORE)}
                </div>
                <div className="form-check">
                  {renderCheckboxFormItem('acceptDisc11', DisclaimerType.HNW_INVESTMENT_10_MILLION)}
                </div>
              </div>
            </div>
            <div className="modal-mnc-footer">
              <div className="row justify-content-center">
                <div className="col-6 pe-1 pe-md-2">
                  <div className="d-grid">
                    <Button data-logout-btn className="btn button-ktb-line" onClick={_onCancel}>
                      <IntlMessages id="global.cancel" />
                    </Button>
                  </div>
                </div>
                <div className="col-6 ps-1 ps-md-2">
                  <div className="d-grid">
                    <Form.Item noStyle shouldUpdate className="d-grid m-0">
                      {(form) => {
                        const { acceptDisc09, acceptDisc10, acceptDisc11 } 
                          = form.getFieldsValue(['acceptDisc09', 'acceptDisc10', 'acceptDisc11'])
                        const acceptSomeChoice = acceptDisc09 || acceptDisc10 || acceptDisc11
                        return (
                          <Button 
                            htmlType="submit"
                            data-accept-btn 
                            className="btn button-ktb-main"
                            disabled={!acceptSomeChoice}
                          >
                            <IntlMessages id="global.confirm" />
                            <i className="feather-icon icon-chevron-right ms-1"></i>
                          </Button>
                        )
                      }}
                    </Form.Item>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Form>
      )}
    </Modal>
  )
}

export default memo(HNW)